export const CLIENT_ADDRESS_SCHEMA = {
    clientAddressTypeId: 0,
    clientAddressType: {
        id: "",
        name: ""
    },
    street: "",
    street2: "",
    zipCode: "",
    city: "",
    state: "",
    countryId: "",
    addressId: 0,
}

export const CLIENT_TAX_SCHEMA = {
    invoiceRequired: false,
    rfc: "",
    clientType: "",
    taxRegimeId: "",
    razonSocial: "",
    codigoPostal: "",
}

export const CLIENT_DOCUMENT_SCHEMA = {
    url: "",
    number: "",
    expirationDate: ""
}

export const CLIENT_RESERVATION_SCHEMA = {
    firstName: null,
    lastName: null,
    phone: null,
    email: null,
    address: CLIENT_ADDRESS_SCHEMA,
    taxData: CLIENT_TAX_SCHEMA,
    dateOfBirth: null,
    documents: {
        license: CLIENT_DOCUMENT_SCHEMA,
        id: CLIENT_DOCUMENT_SCHEMA
    }
}
